export const LESSON_FLOWS = [
  {
    lessonFlowId: 'ski_turn_initiation_intro_v1',
    sport: 'skiing',
    skillId: 'ski_lower_intermediate_turn_initiation',
    stages: {
      review: ['ski_garland_review'],
      stationary_feel: ['ski_static_edge_feel'],
      base_drill: ['ski_edge_release_slip'],
      progression_drill: ['ski_edging_j_tracks'],
      application_drill: ['ski_blue_run_application'],
    },
  },
  {
    lessonFlowId: 'ski_turn_shape_control_v1',
    sport: 'skiing',
    skillId: 'ski_intermediate_turn_shape_control',
    stages: {
      review: ['ski_large_controlled_turns_check'],
      stationary_feel: ['ski_static_edge_feel'],
      base_drill: ['ski_garland_review'],
      progression_drill: ['ski_outside_ski_corridor'],
      application_drill: ['ski_blue_run_application'],
    },
  },
  {
    lessonFlowId: 'ski_carving_intro_v1',
    sport: 'skiing',
    skillId: 'ski_carving_edge_angles',
    stages: {
      review: ['ski_large_controlled_turns_check'],
      stationary_feel: ['ski_static_edge_feel'],
      base_drill: ['ski_edging_j_tracks'],
      progression_drill: ['ski_railroad_tracks_intro'],
      application_drill: ['ski_carving_challenge_run'],
    },
  },
  {
    lessonFlowId: 'snowboard_edge_change_intro_v1',
    sport: 'snowboarding',
    skillId: 'snowboard_lower_intermediate_edge_change',
    stages: {
      review: ['snowboard_turns_review'],
      stationary_feel: ['snowboard_flat_base_feel'],
      base_drill: ['snowboard_heel_toe_patience'],
      progression_drill: ['snowboard_quiet_upper_body'],
      application_drill: ['snowboard_corridor_challenge'],
    },
  },
  {
    lessonFlowId: 'snowboard_turn_shape_v1',
    sport: 'snowboarding',
    skillId: 'snowboard_intermediate_turn_shape',
    stages: {
      review: ['snowboard_turns_review'],
      stationary_feel: ['snowboard_flat_base_feel'],
      base_drill: ['snowboard_heel_toe_patience'],
      progression_drill: ['snowboard_quiet_upper_body'],
      application_drill: ['snowboard_corridor_challenge'],
    },
  },
  {
    lessonFlowId: 'snowboard_carving_intro_v1',
    sport: 'snowboarding',
    skillId: 'snowboard_carving_edge_commitment',
    stages: {
      review: ['snowboard_turns_review'],
      stationary_feel: ['snowboard_static_edge_feel'],
      base_drill: ['snowboard_j_turns_clean_edge'],
      progression_drill: ['snowboard_quiet_upper_body'],
      application_drill: ['snowboard_clean_arc_laps'],
    },
  },
];

export function getLessonFlowForSkill(skillId) {
  return LESSON_FLOWS.find((flow) => flow.skillId === skillId) || null;
}
